import { render, staticRenderFns } from "./VehicleBrandsList.vue?vue&type=template&id=051ba6ef"
import script from "./VehicleBrandsList.vue?vue&type=script&lang=js"
export * from "./VehicleBrandsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports